export default {
    state: () => ({
      count: 0,
    }),
    mutations: {
      increment(state) {
        state.count++;
      },
      decrement(state) {
        state.count--;
      },
      reset(state) {
        console.log("Before reset:", state.count);
        state.count = 0;
        console.log("After reset:", state.count);
      },
    },
  };